<template>
  <v-navigation-drawer
    id="drawer"
    v-model="drawer"
    right
    absolute
    bottom
    temporary
    hide-overlay
  >
    <v-col v-if="item">
      <v-row class="pl-10 pt-5">
        <v-col cols="11">
          <v-row justify="start">
            <div class="identity text weight-600"
              >{{ item.firstname }} {{ item.lastname }}</div
            >
            <v-icon large class="pl-5 material-icons-outlined">
              edit
            </v-icon>
          </v-row>
        </v-col>
        <v-col cols="1">
          <v-icon
            large
            class="ml-3 close-icon material-icons-outlined"
            @click="closeDrawer"
          >
            close
          </v-icon>
        </v-col>
      </v-row>
      <v-row class="pl-6">
        <v-col cols="6">
          <v-row align="center" justify="center">
            <v-col cols="1">
              <v-icon large class="event-icon material-icons-outlined"
                >event</v-icon
              >
            </v-col>
            <v-col cols="11">
              <div class="pl-2">Date d'inscription : {{ item.created_at }}</div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row align="center" justify="center">
            <v-col cols="1">
              <v-icon large class="avatar-icon material-icons-outlined"
                >account_circle</v-icon
              >
            </v-col>
            <v-col cols="11">
              <div class="pl-2">Client Opt-in</div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider class="mt-5 mb-5"></v-divider>
      <v-col>
        <v-row class="mt-3 pl-7" justify="start">
          <div class="personalInfo">Informations personnelles</div>
        </v-row>
        <v-row>
          <v-row class="px-7 pt-4">
            <TextInput
              outlined
              v-model="customer.firstname"
              placeholder="Prénom"
              label="Prénom"
              @changed="updateCustomer"
            />
            <TextInput
              outlined
              v-model="customer.lastname"
              placeholder="Nom"
              label="Nom"
              @changed="updateCustomer"
            />
          </v-row>
        </v-row>
        <v-row class="px-1">
          <v-col cols="8">
            <TextInput
              outlined
              v-model="customer.email"
              placeholder="Email"
              label="Adresse email"
              @changed="updateCustomer"
            />
          </v-col>
          <v-col cols="4">
            <TextInput
              outlined
              v-model="customer.phone"
              placeholder="Téléphone"
              label="Téléphone"
              @changed="updateCustomer"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-row class="pl-4 pt-2 segment-subtitle">Segment</v-row>
          <v-row class="px-4">
            <v-col align="center" class="switch-input" cols="4" v-for="segment in segments" :key="segment.id">
              <v-switch
                hide-details
                :color="segment.color"
                :label="segment.label"
                v-model="customer.segments"
                :value="segment.id"
                :model-value="customer.segments.includes(segment.id)"
                @change="updateCustomerSegments"
              />
            </v-col>
          </v-row>
        </v-row>
      </v-col>
    </v-col>
  </v-navigation-drawer>
</template>

<script type="text/javascript">
import TextInput from '@/components/input/textInput';
import BorderedCard from '@/components/cards/bordered-card.vue';

export default {
  components: {
    TextInput,
    BorderedCard,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      drawer: false,
      customer: {
        firstname: null,
        lastname: null,
        email: null,
        phone: null,
        segments: []
      }
    };
  },

  watch: {
    item() {
      console.log(this.item)
      this.customer.firstname = this.item.firstname
      this.customer.lastname = this.item.lastname
      this.customer.email = this.item.email
      this.customer.phone = this.item.phone_number
      this.customer.segments = []
      this.item.segments.forEach((_segment) => {
        this.customer.segments.push(_segment.id)
      })
    },
  },
  methods: {
    openDrawer() {
      this.drawer = true;
    },
    closeDrawer() {
      this.drawer = false;
    },
    updateCustomerSegments() {
      this.$store.dispatch("customer/updateCustomerSegments", {customer_id: this.item.id, segments: this.customer.segments})
    },
    updateCustomer() {
      this.$store.dispatch("customer/updateCustomer", {customer_id: this.item.id, customer: this.customer})
    }
  },
  computed: {
    segments() {
      return this.$store.state.segments.list
    }
  },
};
</script>

<style lang="scss">
#drawer {
  width: 890px !important;
  margin-right: 31px;
  margin-top: 36px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  .v-navigation-drawer__content {
    height: calc(100vh - 60px);
  }
  .v-tabs-bar .v-tabs-bar__content > *:last-child {
    margin-right: 0px !important;
  }
  .v-tab--active {
    width: 50%;
    padding-left: 3% !important;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    color: black;
    margin-left: 0px !important;
    background-color: #8179fe;
    color: #ffffff !important;
  }
  .v-tab {
    color: black;
    margin-right: 20% !important;
  }
  .v-tab::hover {
    color: #ffffff !important;
  }
  .v-tabs-slider-wrapper {
    height: 4px !important;
    left: 0px !important;
    width: 100% !important;
    color: #8179fe !important;
  }
  .v-slide-group__content {
    background-color: #ffffff;
  }
  .close-icon {
    margin-top: -40px;
    color: $color-secondary;
  }
  .event-icon {
    color: $color-secondary;
  }
  .avatar-icon {
    color: $green-base;
  }
  .identity {
    font-size: 33px;
    letter-spacing: 0.33px;
    color: $color-secondary;
  }
  .personalInfo {
    color: $purple-drawer;
    font-size: 22px;
  }
  .segment-subtitle {
    color: $purple-drawer;
    font-size: 22px;
  }
  .passage-time {
    color: $color-primary;
  }
  .item-card {
    height: 58px;
    border: 1px solid #f1efff;
  }
  .tabs-item {
    height: 400px;
  }
  .tab-item {
    overflow: scroll;
    overflow-x: hidden;
  }
}
</style>
